import { Controller } from "@hotwired/stimulus"

export default class QuizController extends Controller {
  static targets = ["option"]
  static values = { total: Number }

  declare readonly optionTargets: HTMLElement[]
  declare readonly totalValue: number

  connect() {
    this.animateOptionsIn()
  }

  selectOption(event: Event) {
    if (this.element instanceof HTMLElement && this.element.dataset["locked"]) return
    if (this.element instanceof HTMLElement) this.element.dataset["locked"] = "true"

    const btn = event.currentTarget as HTMLElement
    const mouseEvent = event as MouseEvent

    this.burst(mouseEvent.clientX, mouseEvent.clientY)

    btn.animate(
      [
        { boxShadow: "0 0 0 0 rgba(212,175,55,0)", borderColor: "rgba(76,29,149,0.4)" },
        {
          boxShadow: "0 0 32px 6px rgba(212,175,55,0.5), inset 0 0 24px rgba(212,175,55,0.08)",
          borderColor: "rgba(212,175,55,0.9)",
        },
      ],
      { duration: 400, fill: "forwards", easing: "ease-out" }
    )

    this.optionTargets.forEach((el) => {
      if (el === btn) return
      el.animate(
        [
          { opacity: "1", filter: "blur(0px)" },
          { opacity: "0.18", filter: "blur(3px)" },
        ],
        { duration: 280, fill: "forwards", easing: "ease-out" }
      )
    })
  }

  private animateOptionsIn() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    this.optionTargets.forEach((el, i) => {
      el.style.opacity = "0"
      el.animate(
        [
          { opacity: "0", transform: "translateY(18px) scale(0.97)" },
          { opacity: "1", transform: "translateY(0) scale(1)" },
        ],
        {
          duration: 420,
          delay: 180 + i * 110,
          easing: "cubic-bezier(0.34, 1.4, 0.64, 1)",
          fill: "forwards",
        }
      )
    })
  }

  private burst(x: number, y: number) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    const glyphs = ["✦", "✧", "⋆", "·", "✺", "◈", "⊹", "✼", "⁎"]
    const colors = ["#D4AF37", "#F4C430", "#d8bfff", "#bb93ff", "#fde047", "#F4C430"]
    const count = 14

    for (let i = 0; i < count; i++) {
      const el = document.createElement("span")
      el.textContent = glyphs[i % glyphs.length] ?? "✦"
      el.setAttribute("aria-hidden", "true")
      Object.assign(el.style, {
        position: "fixed",
        left: x + "px",
        top: y + "px",
        pointerEvents: "none",
        zIndex: "9999",
        color: colors[i % colors.length] ?? "#D4AF37",
        fontSize: 7 + Math.random() * 12 + "px",
        willChange: "transform, opacity",
        userSelect: "none",
        lineHeight: "1",
      })
      document.body.appendChild(el)

      const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.5
      const dist = 40 + Math.random() * 90
      const tx = Math.cos(angle) * dist
      const ty = Math.sin(angle) * dist

      el.animate(
        [
          { transform: "translate(-50%, -50%) scale(1.6)", opacity: "1" },
          {
            transform: `translate(calc(-50% + ${tx}px), calc(-50% + ${ty}px)) scale(0)`,
            opacity: "0",
          },
        ],
        {
          duration: 550 + Math.random() * 350,
          easing: "cubic-bezier(0.1, 0.9, 0.4, 1)",
          fill: "forwards",
        }
      ).onfinish = () => el.remove()
    }
  }
}
